import React from 'react';
import PropTypes from 'prop-types';

import {
  getUserFields,
  getUserFieldByRole,
} from '../../helpers/UserFields';

const UserProfilePhone = ({ profile }) => {
  const userFields = getUserFields(profile);
  const phone = getUserFieldByRole(userFields, 'phone');

  if (!(phone && phone.value)) {
    return null;
  }

  return (
    <li className="user-profile-phone">
      <i className="far fa-mobile" />
      <a href={`tel:${phone.value}`}>
        {phone.value}
      </a>
    </li>
  );
};

UserProfilePhone.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default UserProfilePhone;
